import { usePatientAllMedications } from '@hook'
import { useSearchParams } from 'react-router-dom'
import ResultsTableLayout from '../Results/tableLayout'
import MedicationsTable from './MedicationsTable'

export default function Medications() {
  const [searchParams] = useSearchParams()
  const searchKey = 'chartMedicationSearch'
  const { includedData, medicationIsLoading, medications } = usePatientAllMedications({
    query: searchParams.get(searchKey) || undefined
  })

  return (
    <ResultsTableLayout records={medications || []} searchKey={searchKey} title="Medications">
      {records => (
        <MedicationsTable included={includedData || []} isLoading={medicationIsLoading} records={records as any} />
      )}
    </ResultsTableLayout>
  )
}
